// Generat automat din README.md
import React, { useState } from 'react';
import { BarChart3, TrendingUp, Target, Eye, Users, DollarSign, MousePointer, Share2, Mail, Calendar, Filter, Download, RefreshCw, Play, Pause } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const AnalizaPerformantaMarketing = () => {
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [filterPeriod, setFilterPeriod] = useState('30');
  const [filterChannel, setFilterChannel] = useState('Toate');

  // Mock data pentru marketing analytics
  const marketingData = {
    overview: {
      totalCampaigns: 24,
      activeCampaigns: 8,
      totalSpent: '45,230',
      totalROI: '285%'
    },
    kpis: {
      impressions: 1250000,
      clicks: 18750,
      conversions: 856,
      ctr: 1.5,
      conversionRate: 4.56,
      cpc: 2.41,
      costPerConversion: 52.84,
      roas: 3.85
    },
    campaigns: [
      {
        id: 1,
        name: 'Campanie Primăvară 2024',
        type: 'Google Ads',
        status: 'Activă',
        startDate: '2024-03-01',
        endDate: '2024-04-30',
        budget: 15000,
        spent: 12450,
        impressions: 450000,
        clicks: 6750,
        conversions: 324,
        revenue: 48600,
        ctr: 1.5,
        conversionRate: 4.8,
        roi: 290,
        targetAudience: 'Femei 25-45 ani',
        locations: ['București', 'Cluj-Napoca', 'Timișoara'],
        devices: { desktop: 45, mobile: 40, tablet: 15 }
      },
      {
        id: 2,
        name: 'Social Media Brand Awareness',
        type: 'Facebook/Instagram',
        status: 'Activă',
        startDate: '2024-02-15',
        endDate: '2024-05-15',
        budget: 8000,
        spent: 6200,
        impressions: 820000,
        clicks: 12300,
        conversions: 156,
        revenue: 18720,
        ctr: 1.5,
        conversionRate: 1.27,
        roi: 202,
        targetAudience: 'Ambele sexe 20-50 ani',
        locations: ['Național'],
        devices: { desktop: 25, mobile: 65, tablet: 10 }
      },
      {
        id: 3,
        name: 'Email Marketing Q1 2024',
        type: 'Email Campaign',
        status: 'Finalizată',
        startDate: '2024-01-01',
        endDate: '2024-03-31',
        budget: 2500,
        spent: 2380,
        impressions: 125000,
        clicks: 3750,
        conversions: 185,
        revenue: 22200,
        ctr: 3.0,
        conversionRate: 4.93,
        roi: 833,
        targetAudience: 'Clienți existenți',
        locations: ['Național'],
        devices: { desktop: 55, mobile: 35, tablet: 10 }
      },
      {
        id: 4,
        name: 'LinkedIn B2B Outreach',
        type: 'LinkedIn Ads',
        status: 'În așteptare',
        startDate: '2024-04-01',
        endDate: '2024-06-30',
        budget: 12000,
        spent: 0,
        impressions: 0,
        clicks: 0,
        conversions: 0,
        revenue: 0,
        ctr: 0,
        conversionRate: 0,
        roi: 0,
        targetAudience: 'Decision makers B2B',
        locations: ['România', 'Ungaria'],
        devices: { desktop: 70, mobile: 25, tablet: 5 }
      },
      {
        id: 5,
        name: 'Retargeting Campaign',
        type: 'Display Ads',
        status: 'Activă',
        startDate: '2024-03-10',
        endDate: '2024-04-10',
        budget: 5000,
        spent: 3800,
        impressions: 680000,
        clicks: 4080,
        conversions: 245,
        revenue: 19600,
        ctr: 0.6,
        conversionRate: 6.01,
        roi: 416,
        targetAudience: 'Vizitatori website',
        locations: ['Național'],
        devices: { desktop: 50, mobile: 40, tablet: 10 }
      },
      {
        id: 6,
        name: 'YouTube Video Ads',
        type: 'Video Marketing',
        status: 'Oprită',
        startDate: '2024-02-01',
        endDate: '2024-02-28',
        budget: 6000,
        spent: 5850,
        impressions: 320000,
        clicks: 1920,
        conversions: 67,
        revenue: 8040,
        ctr: 0.6,
        conversionRate: 3.49,
        roi: 37,
        targetAudience: 'Bărbați 30-55 ani',
        locations: ['București', 'Constanța'],
        devices: { desktop: 30, mobile: 55, tablet: 15 }
      }
    ],
    channelPerformance: [
      {
        channel: 'Google Ads',
        campaigns: 8,
        spent: 28500,
        conversions: 1240,
        revenue: 85600,
        roi: 200,
        avgCPC: 2.89
      },
      {
        channel: 'Facebook/Instagram',
        campaigns: 6,
        spent: 15200,
        conversions: 680,
        revenue: 42800,
        roi: 182,
        avgCPC: 1.95
      },
      {
        channel: 'Email Marketing',
        campaigns: 4,
        spent: 3500,
        conversions: 420,
        revenue: 50400,
        roi: 1340,
        avgCPC: 0.83
      },
      {
        channel: 'LinkedIn Ads',
        campaigns: 3,
        spent: 8900,
        conversions: 156,
        revenue: 28080,
        roi: 215,
        avgCPC: 4.25
      },
      {
        channel: 'Display Ads',
        campaigns: 2,
        spent: 6800,
        conversions: 310,
        revenue: 24800,
        roi: 265,
        avgCPC: 1.67
      },
      {
        channel: 'Video Marketing',
        campaigns: 1,
        spent: 5850,
        conversions: 67,
        revenue: 8040,
        roi: 37,
        avgCPC: 3.05
      }
    ],
    monthlyTrends: [
      { month: 'Ianuarie', spent: 12500, revenue: 35600, conversions: 420, roi: 185 },
      { month: 'Februarie', spent: 15200, revenue: 42800, conversions: 580, roi: 182 },
      { month: 'Martie', spent: 18900, revenue: 58200, conversions: 720, roi: 208 }
    ]
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Activă': return 'success';
      case 'Finalizată': return 'info';
      case 'În așteptare': return 'warning';
      case 'Oprită': return 'error';
      default: return 'default';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Google Ads': return 'info';
      case 'Facebook/Instagram': return 'error';
      case 'Email Campaign': return 'success';
      case 'LinkedIn Ads': return 'warning';
      case 'Display Ads': return 'default';
      case 'Video Marketing': return 'error';
      default: return 'default';
    }
  };

  const getROIColor = (roi) => {
    if (roi >= 300) return 'text-green-600 font-bold';
    if (roi >= 150) return 'text-blue-600 font-medium';
    if (roi >= 100) return 'text-yellow-600';
    return 'text-red-600';
  };

  // Filtrarea campaniilor
  const filteredCampaigns = marketingData.campaigns.filter(campaign => {
    const matchesChannel = filterChannel === 'Toate' || campaign.type === filterChannel;
    
    let matchesDate = true;
    if (filterPeriod !== 'toate') {
      const startDate = new Date(campaign.startDate);
      const today = new Date();
      const daysDiff = Math.floor((today - startDate) / (1000 * 60 * 60 * 24));
      
      switch (filterPeriod) {
        case '7':
          matchesDate = daysDiff <= 7;
          break;
        case '30':
          matchesDate = daysDiff <= 30;
          break;
        case '90':
          matchesDate = daysDiff <= 90;
          break;
      }
    }
    
    return matchesChannel && matchesDate;
  });

  const campaignColumns = [
    { 
      header: 'Campanie', 
      key: 'name',
      render: (value, row) => (
        <div>
          <div className="font-medium text-gray-900 dark:text-white">{value}</div>
          <div className="text-sm text-gray-500">{row.startDate} - {row.endDate}</div>
        </div>
      )
    },
    { 
      header: 'Canal', 
      key: 'type',
      render: (value) => <Badge variant={getTypeColor(value)}>{value}</Badge>
    },
    { 
      header: 'Status', 
      key: 'status',
      render: (value) => <Badge variant={getStatusColor(value)}>{value}</Badge>
    },
    { 
      header: 'Buget/Cheltuit', 
      key: 'budget',
      render: (value, row) => (
        <div className="text-sm">
          <div className="font-medium">{value.toLocaleString('ro-RO')} RON</div>
          <div className="text-gray-500">{row.spent.toLocaleString('ro-RO')} cheltuit</div>
        </div>
      )
    },
    { 
      header: 'CTR', 
      key: 'ctr',
      render: (value) => <span className="font-medium">{value}%</span>
    },
    { 
      header: 'Conversii', 
      key: 'conversions',
      render: (value, row) => (
        <div className="text-sm">
          <div className="font-medium">{value}</div>
          <div className="text-gray-500">{row.conversionRate}% rate</div>
        </div>
      )
    },
    { 
      header: 'Venituri', 
      key: 'revenue',
      render: (value) => (
        <span className="font-bold text-primary-600">{value.toLocaleString('ro-RO')} RON</span>
      )
    },
    { 
      header: 'ROI', 
      key: 'roi',
      render: (value) => (
        <span className={getROIColor(value)}>{value}%</span>
      )
    },
    {
      header: 'Acțiuni',
      key: 'actions',
      render: (_, row) => (
        <div className="flex space-x-1">
          <button
            onClick={() => {
              setSelectedCampaign(row);
              setShowCampaignModal(true);
            }}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          {row.status === 'Activă' ? (
            <button
              className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-red-500"
              title="Pauză campanie"
            >
              <Pause className="w-4 h-4" />
            </button>
          ) : row.status === 'În așteptare' ? (
            <button
              className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-green-500"
              title="Start campanie"
            >
              <Play className="w-4 h-4" />
            </button>
          ) : null}
        </div>
      )
    }
  ];

  const channelColumns = [
    { header: 'Canal', key: 'channel' },
    { header: 'Campanii', key: 'campaigns' },
    { 
      header: 'Cheltuit', 
      key: 'spent',
      render: (value) => `${value.toLocaleString('ro-RO')} RON`
    },
    { header: 'Conversii', key: 'conversions' },
    { 
      header: 'Venituri', 
      key: 'revenue',
      render: (value) => (
        <span className="font-bold text-primary-600">{value.toLocaleString('ro-RO')} RON</span>
      )
    },
    { 
      header: 'ROI', 
      key: 'roi',
      render: (value) => (
        <span className={getROIColor(value)}>{value}%</span>
      )
    },
    { 
      header: 'CPC Mediu', 
      key: 'avgCPC',
      render: (value) => `${value} RON`
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Analiză Performanță Marketing</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Dashboard complet cu metrici, ROI și optimizări pentru campaniile de marketing
          </p>
        </div>
        <div className="flex space-x-3">
          <button className="btn-secondary">
            <RefreshCw className="w-4 h-4 mr-2" />
            Actualizează
          </button>
          <button className="btn-secondary">
            <Download className="w-4 h-4 mr-2" />
            Export Raport
          </button>
          <button className="btn-primary">
            <Target className="w-4 h-4 mr-2" />
            Campanie Nouă
          </button>
        </div>
      </div>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Total Campanii" subtitle="Toate canalurile" icon={Target}>
          <div className="text-2xl font-bold text-primary-600">{marketingData.overview.totalCampaigns}</div>
          <div className="text-sm text-blue-600">{marketingData.overview.activeCampaigns} active</div>
        </Card>
        <Card title="Buget Cheltuit" subtitle="Luna curentă" icon={DollarSign}>
          <div className="text-2xl font-bold text-primary-600">{marketingData.overview.totalSpent} RON</div>
          <div className="text-sm text-green-600">În limitele bugetului</div>
        </Card>
        <Card title="ROI General" subtitle="Toate campaniile" icon={TrendingUp}>
          <div className="text-2xl font-bold text-primary-600">{marketingData.overview.totalROI}</div>
          <div className="text-sm text-green-600">+18% față de luna trecută</div>
        </Card>
        <Card title="Conversii" subtitle="Luna curentă" icon={Target}>
          <div className="text-2xl font-bold text-primary-600">{marketingData.kpis.conversions}</div>
          <div className="text-sm text-green-600">+{marketingData.kpis.conversionRate}% rata medie</div>
        </Card>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card title="Impresii" subtitle="Total" icon={Eye}>
          <div className="text-xl font-bold text-primary-600">
            {(marketingData.kpis.impressions / 1000000).toFixed(1)}M
          </div>
        </Card>
        <Card title="Click-uri" subtitle="Total" icon={MousePointer}>
          <div className="text-xl font-bold text-primary-600">
            {marketingData.kpis.clicks.toLocaleString('ro-RO')}
          </div>
        </Card>
        <Card title="CTR Mediu" subtitle="Click-through rate" icon={BarChart3}>
          <div className="text-xl font-bold text-primary-600">{marketingData.kpis.ctr}%</div>
        </Card>
        <Card title="CPC Mediu" subtitle="Cost per click" icon={DollarSign}>
          <div className="text-xl font-bold text-primary-600">{marketingData.kpis.cpc} RON</div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card title="Performanța Campaniilor" subtitle="Analiză detaliată cu filtrare">
            {/* Filtre */}
            <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Perioada
                </label>
                <select 
                  value={filterPeriod}
                  onChange={(e) => setFilterPeriod(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
                >
                  <option value="toate">Toate perioadele</option>
                  <option value="7">Ultima săptămână</option>
                  <option value="30">Ultima lună</option>
                  <option value="90">Ultimele 3 luni</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Canal
                </label>
                <select 
                  value={filterChannel}
                  onChange={(e) => setFilterChannel(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white"
                >
                  <option value="Toate">Toate canalele</option>
                  <option value="Google Ads">Google Ads</option>
                  <option value="Facebook/Instagram">Facebook/Instagram</option>
                  <option value="Email Campaign">Email Campaign</option>
                  <option value="LinkedIn Ads">LinkedIn Ads</option>
                  <option value="Display Ads">Display Ads</option>
                  <option value="Video Marketing">Video Marketing</option>
                </select>
              </div>

              <div className="flex items-end">
                <button className="btn-secondary w-full">
                  <Filter className="w-4 h-4 mr-2" />
                  Filtre avansate
                </button>
              </div>
            </div>

            {/* Rezultate filtrare */}
            <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
              Afișez {filteredCampaigns.length} din {marketingData.campaigns.length} campanii
            </div>

            <Table columns={campaignColumns} data={filteredCampaigns} />
          </Card>
        </div>

        <div className="space-y-6">
          <Card title="Top Canale" subtitle="Performanță pe canal" icon={BarChart3}>
            <div className="space-y-4">
              {marketingData.channelPerformance
                .sort((a, b) => b.roi - a.roi)
                .slice(0, 5)
                .map((channel, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                  <div>
                    <div className="font-medium text-sm">{channel.channel}</div>
                    <div className="text-xs text-gray-500">{channel.campaigns} campanii</div>
                  </div>
                  <div className="text-right">
                    <div className={`text-sm font-bold ${getROIColor(channel.roi)}`}>
                      {channel.roi}% ROI
                    </div>
                    <div className="text-xs text-gray-500">
                      {channel.conversions} conversii
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card title="Trend Lunar" icon={TrendingUp}>
            <div className="space-y-4">
              {marketingData.monthlyTrends.map((trend, index) => (
                <div key={index} className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium">{trend.month}</span>
                    <Badge variant={getROIColor(trend.roi) === 'text-green-600 font-bold' ? 'success' : 'info'}>
                      {trend.roi}% ROI
                    </Badge>
                  </div>
                  <div className="grid grid-cols-3 gap-2 text-xs">
                    <div>
                      <div className="text-gray-500">Cheltuit</div>
                      <div className="font-medium">{trend.spent.toLocaleString('ro-RO')} RON</div>
                    </div>
                    <div>
                      <div className="text-gray-500">Venituri</div>
                      <div className="font-medium text-primary-600">{trend.revenue.toLocaleString('ro-RO')} RON</div>
                    </div>
                    <div>
                      <div className="text-gray-500">Conversii</div>
                      <div className="font-medium">{trend.conversions}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card title="Acțiuni Rapide">
            <div className="space-y-3">
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Crează A/B Test</span>
                  <Target className="w-4 h-4 text-gray-400" />
                </div>
              </button>
              
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Optimizare Automată</span>
                  <RefreshCw className="w-4 h-4 text-gray-400" />
                </div>
              </button>
              
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Raport Executiv</span>
                  <Download className="w-4 h-4 text-gray-400" />
                </div>
              </button>

              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Alertă Budget</span>
                  <DollarSign className="w-4 h-4 text-gray-400" />
                </div>
              </button>
            </div>
          </Card>
        </div>
      </div>

      <Card title="Performanță pe Canal" subtitle="Analiză comparativă a tuturor canalelor">
        <Table columns={channelColumns} data={marketingData.channelPerformance} />
      </Card>

      {/* Modal pentru detaliile campaniei */}
      <Modal
        isOpen={showCampaignModal}
        onClose={() => {
          setShowCampaignModal(false);
          setSelectedCampaign(null);
        }}
        title={`Detalii Campanie: ${selectedCampaign?.name || ''}`}
      >
        {selectedCampaign && (
          <div className="space-y-6">
            {/* Informații generale */}
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Campanie</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Canal:</span>
                    <Badge variant={getTypeColor(selectedCampaign.type)}>{selectedCampaign.type}</Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Status:</span>
                    <Badge variant={getStatusColor(selectedCampaign.status)}>{selectedCampaign.status}</Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Perioadă:</span>
                    <span>{selectedCampaign.startDate} - {selectedCampaign.endDate}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Target:</span>
                    <span className="text-right">{selectedCampaign.targetAudience}</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Performanță</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Buget:</span>
                    <span className="font-medium">{selectedCampaign.budget.toLocaleString('ro-RO')} RON</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Cheltuit:</span>
                    <span>{selectedCampaign.spent.toLocaleString('ro-RO')} RON</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Impresii:</span>
                    <span>{selectedCampaign.impressions.toLocaleString('ro-RO')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">CTR:</span>
                    <span className="font-medium">{selectedCampaign.ctr}%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Rezultate financiare */}
            <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
              <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Rezultate Financiare</h4>
              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary-600">{selectedCampaign.conversions}</div>
                  <div className="text-sm text-gray-500">Conversii</div>
                  <div className="text-xs text-gray-400">{selectedCampaign.conversionRate}% rata</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-primary-600">
                    {selectedCampaign.revenue.toLocaleString('ro-RO')} RON
                  </div>
                  <div className="text-sm text-gray-500">Venituri</div>
                  <div className="text-xs text-gray-400">Generate</div>
                </div>
                <div className="text-center">
                  <div className={`text-2xl font-bold ${getROIColor(selectedCampaign.roi)}`}>
                    {selectedCampaign.roi}%
                  </div>
                  <div className="text-sm text-gray-500">ROI</div>
                  <div className="text-xs text-gray-400">Return on investment</div>
                </div>
              </div>
            </div>

            {/* Locații target */}
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Locații Target</h4>
              <div className="flex flex-wrap gap-2">
                {selectedCampaign.locations.map((location, index) => (
                  <Badge key={index} variant="default" className="text-xs">{location}</Badge>
                ))}
              </div>
            </div>

            {/* Distribuție pe dispozitive */}
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Distribuție pe Dispozitive</h4>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm">Desktop</span>
                  <div className="flex items-center space-x-2">
                    <div className="w-20 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div 
                        className="bg-blue-600 h-2 rounded-full transition-all duration-300" 
                        style={{ width: `${selectedCampaign.devices.desktop}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium w-8 text-right">{selectedCampaign.devices.desktop}%</span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm">Mobile</span>
                  <div className="flex items-center space-x-2">
                    <div className="w-20 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div 
                        className="bg-green-600 h-2 rounded-full transition-all duration-300" 
                        style={{ width: `${selectedCampaign.devices.mobile}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium w-8 text-right">{selectedCampaign.devices.mobile}%</span>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm">Tablet</span>
                  <div className="flex items-center space-x-2">
                    <div className="w-20 bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div 
                        className="bg-yellow-600 h-2 rounded-full transition-all duration-300" 
                        style={{ width: `${selectedCampaign.devices.tablet}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-medium w-8 text-right">{selectedCampaign.devices.tablet}%</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Acțiuni */}
            <div className="flex justify-end space-x-3 pt-4 border-t">
              <button className="btn-secondary">
                <Download className="w-4 h-4 mr-2" />
                Export Detalii
              </button>
              {selectedCampaign.status === 'Activă' ? (
                <button className="btn-secondary bg-red-50 text-red-600 hover:bg-red-100">
                  <Pause className="w-4 h-4 mr-2" />
                  Pauză Campanie
                </button>
              ) : selectedCampaign.status === 'În așteptare' ? (
                <button className="btn-secondary bg-green-50 text-green-600 hover:bg-green-100">
                  <Play className="w-4 h-4 mr-2" />
                  Start Campanie
                </button>
              ) : null}
              <button 
                className="btn-primary"
                onClick={() => {
                  setShowCampaignModal(false);
                  setSelectedCampaign(null);
                }}
              >
                Închide
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AnalizaPerformantaMarketing;